import AdminSidebar from "admin/sidebar/AdminSidebar";
import { useState } from "react";
import * as XLSX from "xlsx";

const ordersData = [
  {
    id: "WAS-2026-A46EF6",
    date: "1 May",
    time: "11:19 PM",
    provider: "GeoWash",
    location: "Abu Dhabi Mall",
    customer: "Sara M.",
    email: "sara@email.com",
    vehicle: "Mitsubishi Pajero",
    plate: "A12344",
    carType: "SUV",
    service: "Int + Ext",
    shopPrice: 55.0,
    promo: -5.5,
    charged: 49.5,
    stripeFee: -2.44,
    commission: 4.4,
    net: 1.96,
    status: "Completed",
    stripeId: "pi_3PaB2xKZ9mG7fQ4a1mJk0LdR",
    addons: "Tyre Polish",
    promoCode: "FIRST10",
    providerEntitlement: 50.6,
  },
  {
    id: "WAS-2026-95D107",
    date: "1 May",
    time: "10:52 PM",
    provider: "GeoWash",
    location: "Abu Dhabi Mall",
    customer: "Ahmed K.",
    email: "ahmed@email.com",
    vehicle: "Toyota Corolla",
    plate: "B55201",
    carType: "Sedan",
    service: "Exterior",
    shopPrice: 35.0,
    promo: null,
    charged: 35.0,
    stripeFee: -2.02,
    commission: 2.8,
    net: 0.78,
    status: "Completed",
    stripeId: "pi_4QbC3yLZ0nH8gR5b2nKl1MeS",
    addons: "—",
    promoCode: null,
    providerEntitlement: 32.2,
  },
  {
    id: "WAS-2026-53F333",
    date: "1 May",
    time: "10:14 PM",
    provider: "Sparkle UAE",
    location: "Al Reem Island",
    customer: "Maria L.",
    email: "maria@email.com",
    vehicle: "Nissan Patrol",
    plate: "N33720",
    carType: "SUV",
    service: "Full Detail",
    shopPrice: 120.0,
    promo: -12.0,
    charged: 108.0,
    stripeFee: -4.13,
    commission: 12.0,
    net: 7.87,
    status: "Refunded",
    stripeId: "pi_5RcD4zMA1oI9hS6c3oLm2NfT",
    addons: "—",
    promoCode: "FIRST10",
    providerEntitlement: 96.0,
  },
  {
    id: "WAS-2026-29D79D",
    date: "30 Apr",
    time: "09:02 PM",
    provider: "GeoWash",
    location: "Dubai Festival City",
    customer: "James R.",
    email: "james@email.com",
    vehicle: "Honda Accord",
    plate: "D55103",
    carType: "Sedan",
    service: "Exterior",
    shopPrice: 35.0,
    promo: null,
    charged: null,
    stripeFee: null,
    commission: null,
    net: null,
    status: "Expired",
    stripeId: null,
    addons: "—",
    promoCode: null,
    providerEntitlement: null,
  },
  {
    id: "WAS-2026-B77D21",
    date: "29 Apr",
    time: "03:44 PM",
    provider: "GeoWash",
    location: "Yas Mall",
    customer: "Fatima A.",
    email: "fatima@email.com",
    vehicle: "Land Cruiser",
    plate: "K90021",
    carType: "SUV",
    service: "Int + Ext",
    shopPrice: 55.0,
    promo: null,
    charged: 55.0,
    stripeFee: -2.61,
    commission: 4.4,
    net: 1.79,
    status: "Completed",
    stripeId: "pi_6SdE5aNB2pJ0iT7d4pMn3OgU",
    addons: "AC Sterilization",
    promoCode: null,
    providerEntitlement: 50.6,
  },
];

const statusConfig = {
  Completed: { bg: "#d1fae5", color: "#065f46" },
  Refunded: { bg: "#f3f4f6", color: "#374151" },
  Expired: { bg: "#f3f4f6", color: "#6b7280" },
  Pending: { bg: "#fef3c7", color: "#92400e" },
};

function StatusPill({ status }) {
  const cfg = statusConfig[status] || statusConfig.Pending;
  return (
    <span
      style={{
        display: "inline-block",
        fontSize: 9,
        fontWeight: 700,
        padding: "2px 8px",
        borderRadius: 100,
        background: cfg.bg,
        color: cfg.color,
        whiteSpace: "nowrap",
      }}
    >
      {status}
    </span>
  );
}

function Plate({ text }) {
  return (
    <span
      style={{
        fontSize: 9,
        fontWeight: 700,
        background: "#fff9c4",
        color: "#5c4a00",
        border: "1px solid #ffe082",
        borderRadius: 4,
        padding: "1px 6px",
        fontFamily: "monospace",
      }}
    >
      {text}
    </span>
  );
}

function Dash() {
  return <span style={{ color: "#ccc", fontSize: 12 }}>—</span>;
}

function DrawerField({ label, value, color }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <div
        style={{
          fontSize: 9,
          fontWeight: 700,
          color: "#aaa",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: 12, color: color || "#111", fontWeight: 600 }}>
        {value}
      </div>
    </div>
  );
}

// ─── RECEIPT MODAL ────────────────────────────────────────────────────────────
function ReceiptModal({ order, onClose }) {
  if (!order) return null;

  const isExpired = order.status === "Expired";
  const statusColor =
    order.status === "Completed"
      ? "#065f46"
      : order.status === "Refunded"
      ? "#374151"
      : "#6b7280";
  const statusBg =
    order.status === "Completed"
      ? "#d1fae5"
      : order.status === "Refunded"
      ? "#f3f4f6"
      : "#f3f4f6";

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        boxSizing: "border-box",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 14,
          width: "100%",
          maxWidth: 480,
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          fontFamily: "inherit",
        }}
      >
        {/* Receipt Header */}
        <div
          style={{
            background: "#6B5FE4",
            borderRadius: "14px 14px 0 0",
            padding: "20px 22px 18px",
            color: "#fff",
            position: "relative",
          }}
        >
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: 14,
              right: 14,
              background: "rgba(255,255,255,0.15)",
              border: "none",
              borderRadius: "50%",
              width: 28,
              height: 28,
              cursor: "pointer",
              color: "#fff",
              fontSize: 14,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: 1,
            }}
          >
            ✕
          </button>
          <div style={{ fontSize: 11, opacity: 0.75, marginBottom: 4, letterSpacing: "0.05em" }}>
            WASHTA PLATFORM
          </div>
          <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 6 }}>
            Order Receipt
          </div>
          <div
            style={{
              fontFamily: "monospace",
              fontSize: 13,
              background: "rgba(255,255,255,0.15)",
              display: "inline-block",
              padding: "2px 10px",
              borderRadius: 6,
            }}
          >
            {order.id}
          </div>
          <div style={{ marginTop: 10, fontSize: 11, opacity: 0.8 }}>
            {order.date} · {order.time}
          </div>
        </div>

        {/* Status Banner */}
        <div
          style={{
            background: statusBg,
            borderBottom: "1px solid #eee",
            padding: "8px 22px",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: statusColor,
              display: "inline-block",
              flexShrink: 0,
            }}
          />
          <span style={{ fontSize: 11, fontWeight: 700, color: statusColor }}>
            {order.status}
          </span>
          {order.stripeId && (
            <span
              style={{
                marginLeft: "auto",
                fontFamily: "monospace",
                fontSize: 9,
                color: "#888",
                wordBreak: "break-all",
              }}
            >
              {order.stripeId}
            </span>
          )}
        </div>

        {/* Body */}
        <div style={{ padding: "18px 22px", display: "flex", flexDirection: "column", gap: 18 }}>

          {/* Provider + Customer */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <ReceiptSection label="Provider">
              <div style={{ fontWeight: 700, fontSize: 13 }}>{order.provider}</div>
              <div style={{ fontSize: 11, color: "#888" }}>{order.location}</div>
            </ReceiptSection>
            <ReceiptSection label="Customer">
              <div style={{ fontWeight: 700, fontSize: 13 }}>{order.customer}</div>
              <div style={{ fontSize: 11, color: "#888" }}>{order.email}</div>
            </ReceiptSection>
          </div>

          {/* Vehicle */}
          <ReceiptSection label="Vehicle">
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <span style={{ fontWeight: 700, fontSize: 13 }}>{order.vehicle}</span>
              <Plate text={order.plate} />
              <span
                style={{
                  fontSize: 10,
                  background: "#f0f0f0",
                  color: "#555",
                  borderRadius: 4,
                  padding: "1px 6px",
                  fontWeight: 600,
                }}
              >
                {order.carType}
              </span>
            </div>
          </ReceiptSection>

          {/* Service + Addons */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <ReceiptSection label="Service">
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#4a3db8",
                }}
              >
                {order.service}
              </span>
            </ReceiptSection>
            <ReceiptSection label="Add-ons">
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: order.addons === "—" ? "#ccc" : "#1a6641",
                }}
              >
                {order.addons}
              </span>
            </ReceiptSection>
          </div>

          {/* Promo */}
          {order.promoCode && (
            <div
              style={{
                background: "#fffbeb",
                border: "1px dashed #fbbf24",
                borderRadius: 8,
                padding: "8px 12px",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <span style={{ fontSize: 16 }}>🏷️</span>
              <div>
                <span
                  style={{
                    fontFamily: "monospace",
                    fontWeight: 700,
                    fontSize: 12,
                    color: "#92400e",
                  }}
                >
                  {order.promoCode}
                </span>
                <span style={{ fontSize: 11, color: "#92400e", marginLeft: 6 }}>
                  applied · Washta absorbed −AED {Math.abs(order.promo).toFixed(2)}
                </span>
              </div>
            </div>
          )}

          {/* Financial Breakdown */}
          <div>
            <div
              style={{
                fontSize: 9,
                fontWeight: 700,
                color: "#aaa",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                marginBottom: 8,
              }}
            >
              Financial Breakdown
            </div>
            <div
              style={{
                border: "1px solid #eee",
                borderRadius: 10,
                overflow: "hidden",
              }}
            >
              {[
                {
                  label: "Shop Price",
                  value: `AED ${order.shopPrice.toFixed(2)}`,
                  color: "#111",
                  bg: "#fff",
                },
                order.promo != null && {
                  label: "Promo Discount",
                  value: `−AED ${Math.abs(order.promo).toFixed(2)}`,
                  color: "#92400e",
                  bg: "#fffbeb",
                },
                {
                  label: "Charged to Customer",
                  value: isExpired ? "—" : `AED ${order.charged?.toFixed(2)}`,
                  color: "#111",
                  bg: "#f9f9f9",
                  bold: true,
                },
                {
                  label: "Stripe Processing Fee",
                  value: isExpired
                    ? "—"
                    : `−AED ${Math.abs(order.stripeFee).toFixed(2)}`,
                  color: "#991b1b",
                  bg: "#fff",
                },
                {
                  label: "Washta Commission (8%)",
                  value: isExpired
                    ? "—"
                    : `+AED ${order.commission?.toFixed(2)}`,
                  color: "#4a3db8",
                  bg: "#f7f5ff",
                },
                {
                  label: "Washta Net Revenue",
                  value: isExpired ? "—" : `AED ${order.net?.toFixed(2)}`,
                  color: "#065f46",
                  bg: "#f0fdf4",
                  bold: true,
                },
                {
                  label: "Provider Entitlement",
                  value:
                    order.providerEntitlement != null
                      ? `AED ${order.providerEntitlement.toFixed(2)}`
                      : "—",
                  color: "#111",
                  bg: "#fff",
                },
              ]
                .filter(Boolean)
                .map((row, i, arr) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "9px 13px",
                      background: row.bg,
                      borderBottom: i < arr.length - 1 ? "1px solid #f0f0f0" : "none",
                    }}
                  >
                    <span style={{ fontSize: 11, color: "#555" }}>{row.label}</span>
                    <span
                      style={{
                        fontSize: 12,
                        fontFamily: "monospace",
                        fontWeight: row.bold ? 800 : 600,
                        color: row.color,
                      }}
                    >
                      {row.value}
                    </span>
                  </div>
                ))}
            </div>
          </div>

          {/* QB Note */}
          {order.status === "Completed" && (
            <div
              style={{
                background: "#f0fdf4",
                border: "1px solid #bbf7d0",
                borderRadius: 8,
                padding: "8px 12px",
                fontSize: 10,
                color: "#1a6641",
                lineHeight: 1.6,
              }}
            >
              ✅ QB Auto-sync: Entry No.1 fired on completion · one-way to QB only
            </div>
          )}

          {order.status === "Expired" && (
            <div
              style={{
                background: "#f0eeff",
                border: "1px solid #d8d2ff",
                borderRadius: 8,
                padding: "8px 12px",
                fontSize: 10,
                color: "#4a3db8",
                lineHeight: 1.6,
              }}
            >
              ⏱ This order expired (acceptance window timed out). No payment was taken.
            </div>
          )}

          {order.status === "Refunded" && (
            <div
              style={{
                background: "#fff3cd",
                border: "1px solid #fbbf24",
                borderRadius: 8,
                padding: "8px 12px",
                fontSize: 10,
                color: "#92400e",
                lineHeight: 1.6,
              }}
            >
              🔄 Order refunded. QB reversal journal may be required — flag to accountant.
            </div>
          )}
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "12px 22px 16px",
            borderTop: "1px solid #f0f0f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          <span style={{ fontSize: 10, color: "#aaa" }}>
            Generated by Washta Platform
          </span>
          <button
            onClick={onClose}
            style={{
              fontSize: 11,
              fontWeight: 600,
              padding: "7px 18px",
              background: "#6B5FE4",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

function ReceiptSection({ label, children }) {
  return (
    <div>
      <div
        style={{
          fontSize: 9,
          fontWeight: 700,
          color: "#aaa",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          marginBottom: 5,
        }}
      >
        {label}
      </div>
      {children}
    </div>
  );
}

// ─── XLSX EXPORT ──────────────────────────────────────────────────────────────
function exportToXLSX(data) {
  const rows = data.map((o) => ({
    "Order ID": o.id,
    "Date": o.date,
    "Time": o.time,
    "Provider": o.provider,
    "Location": o.location,
    "Customer": o.customer,
    "Email": o.email,
    "Vehicle": o.vehicle,
    "Plate": o.plate,
    "Car Type": o.carType,
    "Service": o.service,
    "Add-ons": o.addons,
    "Promo Code": o.promoCode || "",
    "Shop Price (AED)": o.shopPrice,
    "Promo Discount (AED)": o.promo != null ? Math.abs(o.promo) : "",
    "Charged to Customer (AED)": o.charged != null ? o.charged : "",
    "Stripe Fee (AED)": o.stripeFee != null ? Math.abs(o.stripeFee) : "",
    "Commission (AED)": o.commission != null ? o.commission : "",
    "Washta Net (AED)": o.net != null ? o.net : "",
    "Provider Entitlement (AED)": o.providerEntitlement != null ? o.providerEntitlement : "",
    "Status": o.status,
    "Stripe Payment ID": o.stripeId || "",
  }));

  const ws = XLSX.utils.json_to_sheet(rows);

  // Column widths
  ws["!cols"] = [
    { wch: 20 }, { wch: 10 }, { wch: 10 }, { wch: 15 }, { wch: 22 },
    { wch: 14 }, { wch: 22 }, { wch: 18 }, { wch: 10 }, { wch: 10 },
    { wch: 14 }, { wch: 18 }, { wch: 12 }, { wch: 18 }, { wch: 20 },
    { wch: 24 }, { wch: 18 }, { wch: 18 }, { wch: 18 }, { wch: 24 },
    { wch: 12 }, { wch: 32 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "All Orders");

  // Summary sheet
  const completed = data.filter((o) => o.status === "Completed");
  const totalCharged = completed.reduce((s, o) => s + (o.charged || 0), 0);
  const totalNet = completed.reduce((s, o) => s + (o.net || 0), 0);
  const totalCommission = completed.reduce((s, o) => s + (o.commission || 0), 0);
  const totalProviderPayout = completed.reduce((s, o) => s + (o.providerEntitlement || 0), 0);

  const summaryRows = [
    { Metric: "Total Orders", Value: data.length },
    { Metric: "Completed", Value: data.filter((o) => o.status === "Completed").length },
    { Metric: "Refunded", Value: data.filter((o) => o.status === "Refunded").length },
    { Metric: "Expired", Value: data.filter((o) => o.status === "Expired").length },
    { Metric: "" },
    { Metric: "Total Charged to Customers (AED)", Value: +totalCharged.toFixed(2) },
    { Metric: "Total Washta Commission (AED)", Value: +totalCommission.toFixed(2) },
    { Metric: "Total Stripe Fees (AED)", Value: +data.reduce((s, o) => s + Math.abs(o.stripeFee || 0), 0).toFixed(2) },
    { Metric: "Total Washta Net (AED)", Value: +totalNet.toFixed(2) },
    { Metric: "Total Provider Payouts (AED)", Value: +totalProviderPayout.toFixed(2) },
  ];

  const ws2 = XLSX.utils.json_to_sheet(summaryRows);
  ws2["!cols"] = [{ wch: 38 }, { wch: 18 }];
  XLSX.utils.book_append_sheet(wb, ws2, "Summary");

  XLSX.writeFile(wb, `Washta_Orders_${new Date().toISOString().slice(0, 10)}.xlsx`);
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
export default function AllOrders() {
  const [selectedOrder, setSelectedOrder] = useState(ordersData[0]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All Statuses");
  const [providerFilter, setProviderFilter] = useState("All Providers");
  const [serviceFilter, setServiceFilter] = useState("All Services");
  const [search, setSearch] = useState("");
  const [refundConfirm, setRefundConfirm] = useState(false);
  const [refundReason, setRefundReason] = useState("");
  const [mobileDrawer, setMobileDrawer] = useState(false);
  const [receiptOrder, setReceiptOrder] = useState(null); // receipt modal

  const filtered = ordersData.filter((o) => {
    if (statusFilter !== "All Statuses" && o.status !== statusFilter) return false;
    if (providerFilter !== "All Providers" && o.provider !== providerFilter) return false;
    if (serviceFilter !== "All Services" && o.service !== serviceFilter) return false;
    if (
      search &&
      ![o.id, o.plate, o.customer, o.stripeId || ""]
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    )
      return false;
    return true;
  });

  function openDrawer(order) {
    setSelectedOrder(order);
    setDrawerOpen(true);
    setRefundConfirm(false);
    setRefundReason("");
    setMobileDrawer(true);
  }

  return (
    <div
      className="mainDiv-all-sideBar"
      style={{ display: "flex", minHeight: "100vh", background: "#f0f0f5" }}
    >
      <div className="div-sidebar">
        <AdminSidebar />
      </div>

      <div
        className="div-Dashbaord"
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div style={{ flex: 1, display: "flex", minHeight: 0, overflow: "hidden" }}>
          <div
            style={{
              flex: 1,
              minWidth: 0,
              overflowY: "auto",
              padding: "20px 20px 40px",
            }}
          >
           <h1 className='h1-all-heading'>
              All Orders
            </h1>
            <p style={{ fontSize: 11, color: "#888", marginBottom: 14, lineHeight: 1.5 }}>
              Every transaction across all providers. Click any row to open order detail.
              Expired rows show full data — no money moved.
            </p>

            {/* FILTERS */}
            <div
              style={{
                display: "flex",
                gap: 7,
                alignItems: "center",
                marginBottom: 14,
                flexWrap: "wrap",
              }}
            >
              {["Today", "This Week", "This Month"].map((d) => (
                <button
                  key={d}
                  style={{
                    fontSize: 10,
                    padding: "4px 10px",
                    border: "1px solid #ddd",
                    borderRadius: 20,
                    color: d === "Today" ? "#fff" : "#888",
                    cursor: "pointer",
                    background: d === "Today" ? "#6B5FE4" : "#fff",
                    borderColor: d === "Today" ? "#6B5FE4" : "#ddd",
                  }}
                >
                  {d}
                </button>
              ))}
              {[
                {
                  value: providerFilter,
                  onChange: setProviderFilter,
                  options: ["All Providers", "GeoWash", "Sparkle UAE"],
                },
                {
                  value: statusFilter,
                  onChange: setStatusFilter,
                  options: ["All Statuses", "Completed", "Refunded", "Expired"],
                },
                {
                  value: serviceFilter,
                  onChange: setServiceFilter,
                  options: ["All Services", "Exterior", "Int + Ext", "Full Detail"],
                },
              ].map(({ value, onChange, options }, i) => (
                <select
                  key={i}
                  value={value}
                  onChange={(e) => onChange(e.target.value)}
                  style={{
                    fontSize: 11,
                    color: "#111",
                    border: "1px solid #ddd",
                    borderRadius: 7,
                    padding: "5px 8px",
                    background: "#fff",
                    fontFamily: "inherit",
                  }}
                >
                  {options.map((o) => (
                    <option key={o}>{o}</option>
                  ))}
                </select>
              ))}
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Order ID, plate, customer, Stripe ID…"
                style={{
                  fontSize: 11,
                  border: "1px solid #ddd",
                  borderRadius: 7,
                  padding: "5px 9px",
                  background: "#fff",
                  color: "#111",
                  fontFamily: "inherit",
                  width: 200,
                  marginLeft: "auto",
                }}
              />
              {/* ↓ EXPORT BUTTON */}
              <button
                onClick={() => exportToXLSX(filtered)}
                style={{
                  fontSize: 10,
                  fontWeight: 600,
                  padding: "5px 11px",
                  borderRadius: 7,
                  cursor: "pointer",
                  background: "#fff",
                  color: "#111",
                  border: "1px solid #ddd",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                ↓ Export
              </button>
            </div>

            {/* TABLE */}
            <div style={{ overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  minWidth: 900,
                }}
              >
                <thead>
                  <tr>
                    {[
                      "Order ID",
                      "Date / Time",
                      "Provider · Location",
                      "Customer",
                      "Vehicle",
                      "Service",
                      "Shop Price",
                      "Promo",
                      "Charged",
                      "Stripe Fee",
                      "Commission",
                      "Net",
                      "Status",
                    ].map((h, i) => (
                      <th
                        key={h}
                        style={{
                          fontSize: 9,
                          fontWeight: 700,
                          color: "#aaa",
                          textTransform: "uppercase",
                          letterSpacing: "0.06em",
                          padding: "7px 10px",
                          textAlign: i >= 6 && i <= 11 ? "right" : "left",
                          borderBottom: "1.5px solid #eee",
                          background: "#f7f7f9",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((order) => {
                    const isExpired = order.status === "Expired";
                    const isRefunded = order.status === "Refunded";
                    const isSelected = selectedOrder?.id === order.id && drawerOpen;
                    return (
                      <tr
                        key={order.id}
                        onClick={() => openDrawer(order)}
                        style={{
                          cursor: "pointer",
                          background: isRefunded
                            ? "#fffbeb"
                            : isSelected
                            ? "#f0eeff"
                            : "transparent",
                          transition: "background 0.1s",
                        }}
                        onMouseEnter={(e) => {
                          if (!isSelected) e.currentTarget.style.background = "#fafafa";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = isRefunded
                            ? "#fffbeb"
                            : isSelected
                            ? "#f0eeff"
                            : "transparent";
                        }}
                      >
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <div
                            style={{
                              fontSize: 10,
                              color: "#6B5FE4",
                              fontFamily: "monospace",
                              fontWeight: 600,
                            }}
                          >
                            {order.id}
                          </div>
                        </td>
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <div style={{ fontSize: 11 }}>{order.date}</div>
                          <div style={{ fontSize: 10, color: "#aaa" }}>{order.time}</div>
                        </td>
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <div style={{ fontWeight: 700, fontSize: 11 }}>{order.provider}</div>
                          <div style={{ fontSize: 10, color: "#888" }}>{order.location}</div>
                        </td>
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <div style={{ fontSize: 11 }}>{order.customer}</div>
                          <div style={{ fontSize: 10, color: "#aaa" }}>{order.email}</div>
                        </td>
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <div style={{ fontSize: 11 }}>{order.vehicle}</div>
                          <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 2 }}>
                            <Plate text={order.plate} />
                            <span style={{ fontSize: 9, color: "#888" }}>{order.carType}</span>
                          </div>
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            fontSize: 11,
                            color: isExpired ? "#aaa" : "#4a3db8",
                            fontWeight: 600,
                          }}
                        >
                          {order.service}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                          }}
                        >
                          AED {order.shopPrice.toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                            color: "#92400e",
                          }}
                        >
                          {order.promo ? `−${Math.abs(order.promo).toFixed(2)}` : <Dash />}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                          }}
                        >
                          {isExpired ? <Dash /> : order.charged?.toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                            color: "#991b1b",
                          }}
                        >
                          {isExpired ? <Dash /> : `−${Math.abs(order.stripeFee).toFixed(2)}`}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                            color: "#4a3db8",
                          }}
                        >
                          {isExpired ? <Dash /> : `+${order.commission?.toFixed(2)}`}
                        </td>
                        <td
                          style={{
                            padding: "8px 10px",
                            borderBottom: "1px solid #f5f5f5",
                            textAlign: "right",
                            fontSize: 11,
                            fontFamily: "monospace",
                            fontWeight: 700,
                          }}
                        >
                          {isExpired ? <Dash /> : order.net?.toFixed(2)}
                        </td>
                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #f5f5f5" }}>
                          <StatusPill status={order.status} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div
              style={{
                fontSize: 11,
                color: "#888",
                marginTop: 10,
                paddingTop: 10,
                borderTop: "1px solid #f0f0f0",
              }}
            >
              Showing {filtered.length} of {ordersData.length} ·{" "}
              <span style={{ color: "#6B5FE4", cursor: "pointer" }}>Load more →</span>
            </div>
          </div>

          {/* RIGHT DRAWER PANEL (desktop) */}
          {drawerOpen && selectedOrder && (
            <div
              style={{
                width: 320,
                flexShrink: 0,
                borderLeft: "1px solid #eee",
                overflowY: "auto",
                background: "#fff",
              }}
            >
              {/* Drawer Header */}
              <div
                style={{
                  background: "#f7f7f9",
                  borderBottom: "1px solid #eee",
                  padding: "10px 14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>
                    Order Detail
                  </div>
                  <div
                    style={{
                      fontSize: 10,
                      color: "#6B5FE4",
                      fontFamily: "monospace",
                      marginTop: 2,
                    }}
                  >
                    {selectedOrder.id}
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <StatusPill status={selectedOrder.status} />
                  <button
                    onClick={() => { setDrawerOpen(false); setMobileDrawer(false); }}
                    style={{
                      fontSize: 16,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#888",
                      lineHeight: 1,
                      padding: "0 4px",
                    }}
                  >
                    ✕
                  </button>
                </div>
              </div>

              {/* Drawer Body */}
              <div
                style={{
                  padding: 14,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 14,
                }}
              >
                <DrawerField
                  label="Washta Order ID"
                  value={
                    <span style={{ fontFamily: "monospace", fontSize: 11, color: "#6B5FE4" }}>
                      {selectedOrder.id}
                    </span>
                  }
                />
                <DrawerField
                  label="Date / Time"
                  value={`${selectedOrder.date} · ${selectedOrder.time}`}
                />
                <div style={{ gridColumn: "1 / -1" }}>
                  <DrawerField
                    label="Stripe Payment ID"
                    value={
                      selectedOrder.stripeId ? (
                        <span style={{ fontFamily: "monospace", fontSize: 10, color: "#111" }}>
                          {selectedOrder.stripeId}
                        </span>
                      ) : (
                        <span style={{ color: "#aaa", fontSize: 11 }}>— not charged</span>
                      )
                    }
                  />
                </div>
                <DrawerField
                  label="Provider · Location"
                  value={`${selectedOrder.provider} · ${selectedOrder.location}`}
                />
                <DrawerField
                  label="Customer"
                  value={`${selectedOrder.customer} · ${selectedOrder.email}`}
                />
                <DrawerField
                  label="Vehicle"
                  value={
                    <span>
                      {selectedOrder.vehicle} · <Plate text={selectedOrder.plate} /> ·{" "}
                      {selectedOrder.carType}
                    </span>
                  }
                />
                <DrawerField
                  label="Service"
                  value={<span style={{ color: "#4a3db8" }}>{selectedOrder.service}</span>}
                />
                <DrawerField
                  label="Add-ons"
                  value={<span style={{ color: "#1a6641" }}>{selectedOrder.addons}</span>}
                />
                <DrawerField
                  label="Promo Code"
                  value={
                    selectedOrder.promoCode
                      ? `${selectedOrder.promoCode} · −AED ${Math.abs(selectedOrder.promo).toFixed(2)} · Washta absorbed`
                      : "None"
                  }
                />
                <DrawerField
                  label="Shop Price"
                  value={`AED ${selectedOrder.shopPrice.toFixed(2)}`}
                />
                <DrawerField
                  label="Charged to Customer"
                  value={
                    selectedOrder.charged != null
                      ? `AED ${selectedOrder.charged.toFixed(2)}`
                      : "—"
                  }
                />
                <DrawerField
                  label="Stripe Fee"
                  value={
                    selectedOrder.stripeFee != null ? (
                      <span style={{ color: "#991b1b" }}>
                        − AED {Math.abs(selectedOrder.stripeFee).toFixed(2)}
                      </span>
                    ) : (
                      "—"
                    )
                  }
                />
                <DrawerField
                  label="Commission (8% shop price)"
                  value={
                    selectedOrder.commission != null ? (
                      <span style={{ color: "#4a3db8" }}>
                        + AED {selectedOrder.commission.toFixed(2)}
                      </span>
                    ) : (
                      "—"
                    )
                  }
                />
                <DrawerField
                  label="Washta Net"
                  value={
                    selectedOrder.net != null ? (
                      <span style={{ color: "#1a6641" }}>
                        AED {selectedOrder.net.toFixed(2)}
                      </span>
                    ) : (
                      "—"
                    )
                  }
                />
                <DrawerField
                  label="Provider Entitlement"
                  value={
                    selectedOrder.providerEntitlement != null
                      ? `AED ${selectedOrder.providerEntitlement.toFixed(2)}`
                      : "—"
                  }
                />
                <div style={{ gridColumn: "1 / -1" }}>
                  <DrawerField
                    label="QB Auto-sync"
                    value={
                      selectedOrder.status === "Completed" ? (
                        <span style={{ fontSize: 11, color: "#1a6641" }}>
                          Entry No.1 fired on completion · one-way to QB only
                        </span>
                      ) : (
                        <span style={{ fontSize: 11, color: "#aaa" }}>— not applicable</span>
                      )
                    }
                  />
                </div>
              </div>

              {/* Drawer Actions */}
              <div
                style={{
                  padding: "12px 14px",
                  background: "#fafafa",
                  borderTop: "1px solid #eee",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 8,
                }}
              >
                {/* VIEW RECEIPT — opens modal */}
                <button
                  onClick={() => setReceiptOrder(selectedOrder)}
                  style={{
                    fontSize: 10,
                    fontWeight: 600,
                    padding: "6px 14px",
                    background: "#fff",
                    color: "#6B5FE4",
                    border: "1px solid #d8d2ff",
                    borderRadius: 7,
                    cursor: "pointer",
                  }}
                >
                  View Receipt
                </button>
                {selectedOrder.status === "Completed" && (
                  <button
                    onClick={() => setRefundConfirm(true)}
                    style={{
                      fontSize: 10,
                      fontWeight: 700,
                      padding: "6px 14px",
                      background: "#fee2e2",
                      color: "#991b1b",
                      border: "1px solid #fca5a5",
                      borderRadius: 7,
                      cursor: "pointer",
                    }}
                  >
                    🚩 Flag for Refund
                  </button>
                )}
              </div>

              {/* Refund Confirm */}
              {refundConfirm && (
                <div style={{ padding: "10px 14px 14px" }}>
                  <div
                    style={{
                      background: "#fff3cd",
                      border: "1px solid #fbbf24",
                      borderRadius: 8,
                      padding: "10px 12px",
                      marginBottom: 10,
                      fontSize: 10,
                      color: "#92400e",
                      lineHeight: 1.6,
                    }}
                  >
                    ⚠️ This will mark order as Refunded, notify customer, and log an audit entry.
                    Actual Stripe refund must be processed separately in Stripe Dashboard.
                  </div>
                  <textarea
                    value={refundReason}
                    onChange={(e) => setRefundReason(e.target.value)}
                    placeholder="Reason for refund (required)…"
                    rows={3}
                    style={{
                      width: "100%",
                      fontSize: 11,
                      border: "1px solid #ddd",
                      borderRadius: 7,
                      padding: "7px 9px",
                      fontFamily: "inherit",
                      resize: "vertical",
                      marginBottom: 8,
                      boxSizing: "border-box",
                    }}
                  />
                  <div style={{ display: "flex", gap: 8 }}>
                    <button
                      onClick={() => setRefundConfirm(false)}
                      style={{
                        flex: 1,
                        fontSize: 10,
                        fontWeight: 600,
                        padding: "6px 0",
                        background: "#fff",
                        color: "#666",
                        border: "1px solid #ddd",
                        borderRadius: 7,
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      disabled={!refundReason.trim()}
                      style={{
                        flex: 2,
                        fontSize: 10,
                        fontWeight: 700,
                        padding: "6px 0",
                        background: refundReason.trim() ? "#fee2e2" : "#f3f4f6",
                        color: refundReason.trim() ? "#991b1b" : "#aaa",
                        border: `1px solid ${refundReason.trim() ? "#fca5a5" : "#eee"}`,
                        borderRadius: 7,
                        cursor: refundReason.trim() ? "pointer" : "not-allowed",
                      }}
                    >
                      Confirm Refund Flag
                    </button>
                  </div>
                </div>
              )}

              {selectedOrder.status !== "Completed" && (
                <div
                  style={{
                    margin: "0 14px 14px",
                    background: "#f0eeff",
                    border: "1px solid #d8d2ff",
                    borderRadius: 8,
                    padding: "8px 12px",
                    fontSize: 10,
                    color: "#4a3db8",
                    lineHeight: 1.5,
                  }}
                >
                  {selectedOrder.status === "Expired"
                    ? "This order expired (acceptance window timed out). No payment was taken — no financial impact."
                    : "This order has already been refunded. QB reversal journal may be required — flag to accountant."}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* RECEIPT MODAL */}
      {receiptOrder && (
        <ReceiptModal order={receiptOrder} onClose={() => setReceiptOrder(null)} />
      )}

      <style>{`
        @media (max-width: 768px) {
          .mainDiv-all-sideBar {
            flex-direction: column;
          }
          .div-sidebar {
            width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
}